import { render, staticRenderFns } from "./ViasForHistoryBooking.vue?vue&type=template&id=53eb6d40&scoped=true&"
import script from "./ViasForHistoryBooking.vue?vue&type=script&lang=js&"
export * from "./ViasForHistoryBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb6d40",
  null
  
)

export default component.exports